<template>
    <div class="staff">
<!--      <el-card>-->
<!--        <el-breadcrumb separator="/">-->
<!--          <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>数据统计</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>热门搜索</el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
<!--      </el-card>-->
      <main class="content">
        <el-card>
          <el-form :inline="true" :model="searchForm" size="mini">
            <div>
              <el-radio-group v-model="searchForm.category" size="small" @change="() => {this.currentPage=1;onSearch();}">
                <el-radio-button label="商品分类"></el-radio-button>
                <el-radio-button label="商品品牌"></el-radio-button>
                <el-radio-button label="商品名称"></el-radio-button>
                <el-radio-button label="商品编号"></el-radio-button>
                <el-radio-button label="商品规格"></el-radio-button>
                <el-radio-button label="自由检索"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin-top: 10px">
              <el-form-item label="">
                  <el-radio v-model="searchForm.type" label="company">公司</el-radio>
              </el-form-item>
              <el-form-item label="">
                  <el-select v-model="searchForm.company" filterable clearable placeholder="请选择公司" :disabled="searchForm.type != 'company'" size="mini">
                      <el-option
                          v-for="item in companyOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="">
                  <el-radio v-model="searchForm.type" label="user">用户</el-radio>
              </el-form-item>
              <el-form-item label="">
                  <el-select
                      v-model="searchForm.user"
                      filterable
                      clearable
                      remote
                      reserve-keyword
                      placeholder="请输入用户邮箱"
                      :remote-method="searchUserOption"
                      :disabled="searchForm.type != 'user'"
                      :loading="loading"
                      size="mini">
                      <el-option
                      v-for="item in userOptions"
                      :key="item.id"
                      :label="item.email"
                      :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="起止日期">
                  <el-date-picker
                      v-model="searchForm.date"
                      clearable
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      size="mini">
                  </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
              </el-form-item>
            </div>
          </el-form>
          <div ref="tablePosition"></div>
          <el-table
            stripe
            size="mini"
            :data="tableData"
            v-loading="loading"
            :height="tableConfig.height"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="product"
              label="产品">
            </el-table-column>
            <el-table-column
              prop="cnt"
              label="访问次数">
            </el-table-column>
          </el-table>
          <div style="text-align: center;padding-top: 20px">
            <el-pagination
                background
                layout="sizes,prev, pager, next"
                :page-sizes="[10, 20, 50, 100]"
                v-if="total>0"
                :total="total"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                @current-change="onPageChange"
                :current-page="currentPage"
                @prev-click="onPageChange"
                @next-click="onPageChange">
            </el-pagination>
          </div>
        </el-card>
      </main>
    </div>
  </template>
  <script>
  const HEIGHT_OFFSET = 118;
  export default {
      data() {
          return {
              pageLoading: undefined,
              tableConfig: {
                  height: 0,
              },
              searchForm: {
                category: "商品分类",
                type: "company",
                company: undefined,
                user: undefined,
                date: undefined,
              },
              companyOptions: [],
              userOptions: [],
              loading: false,
              total: 0,
              pageSize: 10,
              currentPage: 1,
              tableData: [],
          }
      },
      methods: {
          onSearch() {
              this.loading = true;
              let that = this
              this.$axios.post("/admin/statistics/popularSearchCond",{
                  cond: this.searchForm,
                  page: this.currentPage - 1,size:this.pageSize
              }).then(function(response) {
                  let resp = response.data;
                  if(resp.header.status == 0) {
                    that.loading = false;
                    that.tableData = resp.data.content;
                    that.total = resp.data.totalElements;
                  }
              }).catch(function() {
                that.loading = false;
              });
          },
          handleSizeChange(pageSize){
              this.pageSize = pageSize;
              this.onSearch();
          },
          onPageChange(currentPage) {
              this.currentPage = currentPage;
              this.onSearch();
          },
          searchUserOption(query) {
            if(query) {
              let that = this;
              this.$axios.post("/admin/user/list", {email: query}).then(function(response) {
                  let resp = response.data;
                  if(resp.header.status == 0) {
                    that.userOptions = resp.data;
                  } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                  }
              });
            }
          },
          initCompanyOption() {
              let that = this;
              this.$axios.post("/admin/company/list", {}).then(function(response) {
                  let resp = response.data;
                  if(resp.header.status == 0) {
                    that.companyOptions = resp.data;
                  } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                  }
              });
          },
          setTableHeight() {
              const tablePosition = this.$refs['tablePosition'];
              const {top} = tablePosition.getBoundingClientRect();
              this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
          }
      },
      created() {
          this.initCompanyOption();
          this.onSearch();
          window.addEventListener("resize", this.setTableHeight);
      },
      mounted() {
          this.pageLoading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
              this.setTableHeight();
              this.pageLoading.close();
              this.pageLoading = undefined;
          }, 500);
      },
      beforeDestroy() {
          if(this.pageLoading){
              this.pageLoading.close();
              this.pageLoading = undefined;
          }
      },
      destroyed () {
          window.removeEventListener("resize", this.setTableHeight);
      }
  }
  </script>